import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot }  from '@angular/router'

@Injectable()
export class InitDataLoaderResolver implements Resolve<boolean> {
  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return Observable.of(true)
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/init-data-loader.resolver.ts